export const INSCAN_TEXT = {
  nl: {
    logout: "Uitloggen",
    loggedInAs: "Ingelogd als:",

    homeTitle: "Broccoli Voorraad Systeem",
    scannerStandard: "Normaal",
    scannerPlus: "Handmatig",
    scannerModeSelector: "Kies de actieve inscanner",
    scannerModeActive: "Actief",

    startNewBatch: "Begin nieuwe partij",
    batchInfoTitle: "Partijinformatie instellen",

    field: {
      snijgroep: "Snijgroep",
      perceel: "Perceel",
      gewicht: "Gewicht",
      soort: "Soort",
      koelcel: "Koelcel",
      rij: "Rij",
    }, 
    
    noFullWagon: (size) => ` – ⚠ geen volle wagen van 14 kisten`,

    startBatch: "Start Partij",
    endBatch: "Beëindig partij",
    currentBatch: "Huidige partij",

    select: "Selecteer",

    scanCrateLabel: "Scan kist-QR (kist-0001, kist-0002, ...)",
    manualHint: "Druk op Enter om handmatig te scannen.",
    scannedCrates: (n) => `Ingescande kisten deze partij: ${n}`,

    mixing: "Meng partijen op één rij toestaan",

    rowsOverview: "Rijen overzicht",
    latestInscanTitle: "Laatste inscans per partij",
    latestInscanMostRecent: "Meest recent ingescand",
    latestInscanEmpty: "Er zijn nog geen kisten ingescand.",
    latestInscanAlsoAt: "Ook geplaatst op:",
    latestInscanLastScan: "Laatste scan",
    latestInscanCrateCount: (count) => `${count} ${count === 1 ? "kist" : "kisten"}`,
    kistenInCooling: (n) => `${n} kisten in koeling`,
    sortOldestFirst: "Oudste eerst",
    mixed: "gemengd",
     filter: {
    koelcel: "Koelcel",
    rij: "Rij",
    empty: "Leeg",
    },

    deliveryCell: "Aflevercel",
    corCell: "Cor",

    invalidCrate: "Ongeldige kist-code",
    partyLockWarning: "Er staat een partij open — eerst afronden voordat je naar andere pagina's gaat.",


           confirm: {
             overwriteTitle: "Kist overschrijven?",
             inscanDateLabel: "Ingescand op",
             overwriteMessage: ({ barcode, partij, inscanInfo, huidigePartij }) =>
             `${barcode} is al ingescand in\n` +
             `${partij || "onbekend"}${inscanInfo}.\n\n` +
             `Wil je deze kist overschrijven naar de huidige partij\n` +
             `(${huidigePartij})?`,

             logoutWhileActiveTitle: "Partij nog open",
             logoutWhileActiveMessage: () =>
              `Er staat nog een partij open.\n\n` +
              `Als je uitlogt wordt deze partij automatisch beëindigd.\n` +
              `Wil je toch uitloggen?`,

              partialWagonTitle: ({ count }) =>
               `Je hebt ${count} ${count === 1 ? "kist" : "kisten"} ingescand`,
              partialWagonMessage: () =>
               "Weet je zeker dat je deze partij wilt beëindigen?",

              yes: "Ja",
              no: "Nee",
              overwriteonlyplus: (barcode) => `${barcode} is al ingescand. Overschrijven kan alleen door supervisor.`,
              overwriteManualOnly: (barcode) => `${barcode} is al ingescand. Schakel naar Handmatig om deze kist te overschrijven.`,
               },
  


         errors: {
            noRights: "Je hebt geen rechten om in te scannen.",
            partijIncomplete: "Vul eerst alle partijgegevens in!",
            invalidFormat: (barcode) => `Ongeldig formaat: ${barcode}`,
            qrNotRecognized: (barcode) => `QR code niet herkend: ${barcode}`,
            woodAlreadyUsed: (barcode) => `Deze houtenkist is al gebruikt: ${barcode}`,
            whitelistCheckFailed: "Kon whitelist niet controleren. Probeer opnieuw.",
            whitelistNoRights: "Kon whitelist niet controleren (rechten).",
            
            alreadyInSameBatch: ({ barcode, rij, koelcel }) =>
           `${barcode} staat al in deze partij op rij ${rij} (koelcel ${koelcel}) — overgeslagen.`,
            
        
            rowNotFound: "Deze koelcel/rij bestaat niet.",
            rowManuallyOccupied: ({ koelcel, rij }) =>
              `Rij ${koelcel}-${rij} is handmatig als bezet gemarkeerd.`,
            rowOtherPartij: ({ koelcel, rij }) => `Rij ${koelcel}-${rij} bevat al een andere partij!`,
            rowFull: ({ koelcel, rij }) => `Rij ${koelcel}-${rij} is vol.`,

            warmNeighbour: "Kan deze rij niet gebruiken: warme rij naast een andere warme rij!",
            },


  },

  en: {
    logout: "Log out",
    loggedInAs: "Logged in as:",
    
    homeTitle: "Broccoli Inventory System",
    scannerStandard: "Normal",
    scannerPlus: "Manual",
    scannerModeSelector: "Choose the active scanner",
    scannerModeActive: "Active",

    startNewBatch: "Start new batch",
    batchInfoTitle: "Set batch information",

  field: {
    snijgroep: "Group",
    perceel: "Field",
    gewicht: "Weight",
    soort: "Variety",
    koelcel: "Cooling",
    rij: "Row",
  },
    noFullWagon: (size) => ` – ⚠ no full wagon of 14 boxes`,

    startBatch: "Start batch",
    endBatch: "End batch",
    currentBatch: "Current batch",
    
    select: "Select",

    scanCrateLabel: "Scan box QR code (kist-0001, kist-0002, ...)",
    manualHint: "Press Enter to scan manually.",
    scannedCrates: (n) => `Boxes scanned in this batch: ${n}`,

     mixing: "Mixing batches on 1 row enabe",

     
    rowsOverview: "Row overview",
    latestInscanTitle: "Latest scans by batch",
    latestInscanMostRecent: "Most recently scanned",
    latestInscanEmpty: "No boxes have been scanned yet.",
    latestInscanAlsoAt: "Also placed at:",
    latestInscanLastScan: "Latest scan",
    latestInscanCrateCount: (count) => `${count} ${count === 1 ? "box" : "boxes"}`,
    kistenInCooling: (n) => `${n} Boxes in cooling`,
    sortOldestFirst: "Oldest first",
    mixed: "mixed",
    filter: {
    koelcel: "Cooling",
    rij: "Row",
    empty: "Empty",
    },
    deliveryCell: "Delivery cell",
    corCell: "Cor",

    invalidCrate: "Invalid kist-code",
    
    partyLockWarning: "A batch is still active — finish it before navigating to other pages.",

    confirm: {
        overwriteTitle: "Overwrite Box?",
        inscanDateLabel: "Scanned on",
        overwriteMessage: ({ barcode, partij, inscanInfo, huidigePartij }) =>
            `${barcode} was already scanned in\n` +
            `${partij || "unknown"}${inscanInfo}.\n\n` +
            `Do you want to overwrite this Box to the current batch\n` +
            `(${huidigePartij})?`,
       
      logoutWhileActiveTitle: "Batch still active",
        logoutWhileActiveMessage: () =>
            `There is still an active batch.\n\n` +
            `If you log out now, this batch will be closed automatically.\n` +
            `Do you want to continue logging out?`,
        partialWagonTitle: ({ count }) =>
            `You have scanned ${count} ${count === 1 ? "box" : "boxes"}`,
        partialWagonMessage: () =>
            "Are you sure you want to end this batch?",
        yes: "Yes",
        no: "No",
       overwriteonlyplus: (barcode) => `${barcode} already scanned in. Can only overwrite with inscanner+ `,
       overwriteManualOnly: (barcode) => `${barcode} has already been scanned. Switch to Manual to overwrite this box.`,
     },

    errors: {
      noRights: "You are not allowed to scan in.",
      partijIncomplete: "Fill in all information first.",
      invalidFormat: (barcode) => `Invalid format: ${barcode}`,
      qrNotRecognized: (barcode) => `QR code not recognized: ${barcode}`,
      woodAlreadyUsed: (barcode) => `This wooden Box was already used: ${barcode}`,
      whitelistCheckFailed: "Could not validate whitelist. Please try again.",
      whitelistNoRights: "Could not validate whitelist (permissions).",

   

    alreadyInSameBatch: ({ barcode, rij, koelcel }) =>
    `${barcode} is already part of this batch on row ${rij} (Cooling ${koelcel}) — skipped.`,

    


      rowNotFound: "This Cooling/row does not exist.",
      rowManuallyOccupied: ({ koelcel, rij }) =>
        `Row ${koelcel}-${rij} is manually marked as occupied.`,
      rowOtherPartij: ({ koelcel, rij }) => `Row ${koelcel}-${rij} already contains another batch.`,
      rowFull: ({ koelcel, rij }) => `Row ${koelcel}-${rij} is full.`,

      warmNeighbour: "Row cannot be used due to a warm row next to it.",
    },
  },

   pl: {
    logout: "Wyloguj się",
    loggedInAs: "Zalogowany jako:",
    
    homeTitle: "System inwentaryzacji brokuł",
    scannerStandard: "Normalny",
    scannerPlus: "Ręczny",
    scannerModeSelector: "Wybierz aktywny skaner",
    scannerModeActive: "Aktywny",

    startNewBatch: "Rozpocznij nową partie",
    batchInfoTitle: "Ustaw informacje o partii",

  field: {
    snijgroep: "Grupa",
    perceel: "Pole",
    gewicht: "Waga",
    soort: "Odmiana",
    koelcel: "Chłodnia",
    rij: "Rząd",
  },
    noFullWagon: (size) => ` – ⚠ Brak pełnego wagonu(rozmiar) 14`,

    startBatch: "Rozpocznij partię",
    endBatch: "Zakończ partię",
    currentBatch: "Aktualna partia",
    
    select: "Wybrać",

    scanCrateLabel: "Zeskanuj kod QR(skrzyni -0001,skrzyni -0002)",
    manualHint: "Naciśnij Enter,aby skanować ręcznie.",
    scannedCrates: (n) => `Zeskanowane pudełka (skrzynie )w tej partii: ${n}`,

     mixing: "Miesznie partii w 1 rzędzie jest możliwy",

     
    rowsOverview: "Przegląd wierszy",
    latestInscanTitle: "Ostatnie skany według partii",
    latestInscanMostRecent: "Ostatnio zeskanowano",
    latestInscanEmpty: "Nie zeskanowano jeszcze żadnych skrzyń.",
    latestInscanAlsoAt: "Umieszczono również w:",
    latestInscanLastScan: "Ostatni skan",
    latestInscanCrateCount: (count) => `Liczba skrzyń: ${count}`,
    kistenInCooling: (n) => `${n} Pudełka/Skrzynie w chłodni`,
    sortOldestFirst: "Oldest first",
    mixed: "Mieszany",
    filter: {
    koelcel: "Chłodnia",
    rij: "Rząd",
    empty: "Pusto",
    },
    deliveryCell: "Chłodnia 1",
    corCell: "Cor",

    invalidCrate: "Nieprawidłowy kod skrzyni(pudełka)",
    
    partyLockWarning: "Ostrzeżenie o blokadzie:partia jest nadal aktywna-zakończ ją przed przejściem do innej strony/",

    confirm: {
        overwriteTitle: "Zastąp tytuł:przepisać skrzynie?",
        inscanDateLabel: "Zeskanowano dnia",
        overwriteMessage: ({ barcode, partij, inscanInfo, huidigePartij }) =>
            `${barcode} został już zeskanowany\n` +
            `${partij || "nieznany "}${inscanInfo}.\n\n` +
            `Czy chcesz przepisać to tą skrzynie(pudełko) do aktualnej partii\n` +
            `(${huidigePartij})?`,
       
      logoutWhileActiveTitle: "Partia nadal aktywna",
        logoutWhileActiveMessage: () =>
            `Nadal istnieje aktywna partia.\n\n` +
            `Jeśli się teraz wylogujesz ,ta partia zostanie automatycznie zamknięta.\n` +
            `Czy chcesz kontynuować wylogowywanie?`,
        partialWagonTitle: ({ count }) =>
            `Zeskanowano ${count} skrzyń`,
        partialWagonMessage: () =>
            "Czy na pewno chcesz zakończyć tę partię?",
        yes: "Tak",
        no: "Nie",
       overwriteonlyplus: (barcode) => `${barcode} został już zeskanowany. Nadpisanie możliwe tylko przez inscanner+`,
       overwriteManualOnly: (barcode) => `${barcode} został już zeskanowany. Przełącz na tryb Ręczny, aby nadpisać tę skrzynię.`,
     },

    errors: {
      noRights: "Nie masz uprawnień do skanowania.",
      partijIncomplete: "Najpierw uzupełnij wszystkie informacje.",
      invalidFormat: (barcode) => `Nieprawidłowy format: ${barcode}`,
      qrNotRecognized: (barcode) => `Kod QR nie został rozpoznany: ${barcode}`,
      woodAlreadyUsed: (barcode) => `To drewniane pudełko(skrzynia)było już używane: ${barcode}`,
      whitelistCheckFailed: "Nie można zweryfikować białejlisty.Spróbuj ponownie.",
      whitelistNoRights: "Nie można zweryfikować białej listy (uprawnień).",

   

    alreadyInSameBatch: ({ barcode, rij, koelcel }) =>
`${barcode} jest już w tej partii w rzędzie ${rij} (Chłodnia ${koelcel}) — pominięto.`,

    


      rowNotFound: "To chłodnia(rząd) nie istnieje`.",
      rowManuallyOccupied: ({ koelcel, rij }) =>
        `Rzad ${koelcel}-${rij} jest recznie oznaczony jako zajety.`,
      rowOtherPartij: ({ koelcel, rij }) => `Rząd ${koelcel}-${rij} zawiera już inna partię.`,
      rowFull: ({ koelcel, rij }) => `Rząd ${koelcel}-${rij} są już pełne`,

      warmNeighbour: "Rząd nie może zostać użyty,ponieważ obok niego znajduje się ciepły rząd.",
    },
  },
};
